<template>
  <div class="doctor-list-page">
    <header class="page-header">
      <div class="container">
        <div class="breadcrumb-section">
          <h2 class="current-category-title">专家团队</h2>
        </div>
      </div>
    </header>

    <div class="container">
      <aside class="sidebar">
        <div class="sidebar-section">
          <ul class="category-list">
            <li v-for="(dept, index) in expertDepartments" :key="dept.id" class="tree-item">
              <div class="tree-row">
                <span class="expand-icon empty"></span>
                <a href="#" @click.prevent="selectDepartment(index, dept)" 
                   :class="{ active: activeTab === index }">
                  {{ dept.name }}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </aside>

      <main class="main-layout">
        <div class="doctor-content" v-if="currentDepartment">
          <h2 class="dept-title">{{ currentDepartment.name }}</h2>
          <div v-if="currentDepartment.doctors && currentDepartment.doctors.length > 0" class="doctors-grid">
            <div v-for="doctor in currentDepartment.doctors" :key="doctor.id" class="doctor-item">
              <img v-if="doctor.pic_url" :src="getFullImageUrl(doctor.pic_url)" :alt="doctor.name" class="doctor-image cursor-pointer" @click="previewImage(doctor.pic_url)" />
              <div v-else class="no-doctor-image-tip">{{ doctor.name }}</div>
              <p class="doctor-name-text">{{ doctor.name }}</p>
            </div>
          </div>
          <div v-else class="no-doctor-tip">该科室暂无专家</div>
        </div>
        <div v-else class="loading-state">
          加载中...
        </div>
      </main>
    </div>

    <div v-if="previewImageSrc" class="image-preview-overlay" @click="closePreview">
      <img :src="previewImageSrc" alt="预览图片" class="preview-image" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'DoctorList',
  data() {
    return {
      activeTab: 0,
      expertDepartments: [],
      currentDepartment: null,
      previewImageSrc: null
    }
  },
  mounted() {
    this.fetchExpertData()
  },
  methods: {
    async fetchExpertData() {
      try {
        const response = await axios.get('/api/expert-departments-with-doctors')
        this.expertDepartments = response.data.data || []
        if (this.expertDepartments.length > 0) {
          this.selectDepartment(0, this.expertDepartments[0])
        }
      } catch (error) {
        console.error('获取专家数据失败:', error)
      }
    },
    selectDepartment(index, dept) {
      this.activeTab = index
      this.currentDepartment = dept
    },
    getFullImageUrl(picUrl) {
      if (!picUrl) return ''
      if (picUrl.startsWith('http://') || picUrl.startsWith('https://')) {
        return picUrl
      }
      return 'https://www.ynfybj.com' + (picUrl.startsWith('/') ? '' : '/') + picUrl
    },
    previewImage(picUrl) {
      this.previewImageSrc = this.getFullImageUrl(picUrl)
    },
    closePreview() {
      this.previewImageSrc = null
    }
  }
}
</script>

<style lang="less" scoped>
.doctor-list-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.page-header {
  position: sticky;
  top: 198px;
  z-index: 150;
  background: white;
  border-bottom: 1px solid #eee;
  padding: 15px 0;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .breadcrumb-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .breadcrumb {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;

    a {
      color: #4ecdc4;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    span {
      margin: 0 8px;
      color: #999;
    }
  }

  .current-category-title {
    font-size: 36px;
    font-weight: bold;
    color: #4ecdc4;
    margin: 0;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
  display: flex;
  gap: 30px;
}

.sidebar {
  width: 300px;
  flex-shrink: 0;
  position: sticky;
  top: 175px;
  align-self: flex-start;
}

.sidebar-section {
  background: white;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.category-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li.tree-item {
    border-bottom: 1px dashed #eee;

    &:last-child {
      border-bottom: none;
    }

    .tree-row {
      display: flex;
      align-items: center;
      padding: 6px 0;

      .expand-icon {
        cursor: pointer;
        font-size: 8px;
        width: 12px;
        height: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 6px;
        color: #4ecdc4;

        &.empty {
          cursor: default;
          color: transparent;
        }
      }

      a {
        flex: 1;
        font-size: 14px;
        color: #666;
        text-decoration: none;

        &:hover, &.active {
          color: #4ecdc4;
          font-weight: bold;
        }
      }
    }
  }
}

.main-layout {
  flex: 1;
}

.loading-state {
  text-align: center;
  padding: 80px 0;
  color: #999;
  font-size: 16px;
}

.doctor-content {
  flex: 1;
  background: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.dept-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.doctors-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}

.doctor-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.doctor-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
  border-radius: 4px;
  margin-bottom: 12px;
}

.no-doctor-image-tip {
  width: 120px;
  height: 120px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
  border-radius: 4px;
  margin-bottom: 12px;
}

.doctor-name-text {
  display: block;
  font-size: 14px;
  color: #333;
  text-align: center;
  margin: 0;
}

.no-doctor-tip {
  text-align: center;
  padding: 60px 0;
  color: #999;
  font-size: 16px;
}

.cursor-pointer {
  cursor: pointer;
}

.image-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  cursor: zoom-out;
}

.preview-image {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
</style>
